import axios from 'axios';

export class FeedService {

  /**
   * @param {Object} options - options object
   * @param {string} options.baseUrl - Api base url
   */
  constructor(options = {}) {

    let settings = {
      baseUrl: null
    };

    this.settings = Object.assign(settings, options);

    if(!this.settings.baseUrl) {
      throw Error('#constructor: settings.baseUrl needs to be set');
    }

    this.axios = axios.create({
      baseURL: this.settings.baseUrl,
      validateStatus: function(status) {
        return status < 500; // Reject only if the status code is greater than or equal to 500
      }
    });

    // For debugging

    this.axios.interceptors.request.use(function(config) {
      console.log('Full Feed request', config);
      return config;
    });

    this.axios.interceptors.response.use(function(response) {
      console.log('Full Feed response', response);
      return response;
    }, function(error) {
      console.log('Feed error (>=500)', error);
      return Promise.reject(error);
    });
  }

  // RESTful methods

  get(path, params) {
    console.log('feedservice.get', path, params);
    return this._request('get', path, null, params);
  }

  _request(method, path, data = {}, params = {}) {
    return this.axios({
      method,
      url: path,
      data,
      params,
      withCredentials: true,
    });
  }

}
